export default __webpack_public_path__ + "CircularCustCapNum-Medium.a9f95dd80e62f7340ce14d71a72833ac.woff2";